import { IAsyncHandler, IFaq } from '@/study-search/interfaces';
import { CountryFaqHandler, DefaultFaqHandler, DisciplineCountryFaqHandler, DisciplineFaqHandler } from './';

export class FaqBuilder {
	private readonly rootFaqHandler: IAsyncHandler<IFaq[]>;

	constructor() {
		this.rootFaqHandler = new DisciplineCountryFaqHandler();

		this.rootFaqHandler.setNext(new CountryFaqHandler()).setNext(new DisciplineFaqHandler()).setNext(new DefaultFaqHandler());
	}

	public async build(): Promise<IFaq[]> {
		return await this.rootFaqHandler.construct();
	}
}
